import { Language } from "@/hooks/use-browser-language";

type TranslationKey =
  | "title"
  | "section1Title"
  | "section1Text1"
  | "section1Text2"
  | "section2Title"
  | "section2Text"
  | "section3Title"
  | "section3Text"
  | "section3Item1"
  | "section3Item2"
  | "section3Item3"
  | "section4Title"
  | "section4Text"
  | "section4Item1"
  | "section4Item2"
  | "section4Item3"
  | "section4Item4"
  | "section4Item5"
  | "section5Title"
  | "section5Text"
  | "section5Item1"
  | "section5Item2"
  | "section5Item3"
  | "section6Title"
  | "section6Text"
  | "section7Title"
  | "section7Text"
  | "section7Item1"
  | "section7Item2"
  | "section7Item3"
  | "section7Text2"
  | "section8Title"
  | "section8Text"
  | "section9Title"
  | "section9Text"
  | "section9Item1"
  | "section9Item2"
  | "section9Item3"
  | "section9Item4"
  | "section9Item5"
  | "section9Item6"
  | "section9Item7"
  | "section9Item8"
  | "section9Text2"
  | "section10Title"
  | "section10Text"
  | "section11Title"
  | "section11Text";

const translations: Record<Language, Record<TranslationKey, string>> = {
  pl: {
    title: "Polityka Prywatności lifactor.com",
    section1Title: "1. Informacje ogólne",
    section1Text1: "Niniejsza Polityka Prywatności opisuje zasady przetwarzania danych osobowych użytkowników serwisu lifactor.com. Administratorem danych jest właściciel serwisu, kontakt e-mail: miloxiads(at)gmail.com.",
    section1Text2: "Korzystając z serwisu, akceptujesz zasady opisane poniżej.",
    section2Title: "2. Administrator danych",
    section2Text: "Administratorem jest podmiot zarządzający stroną lifactor.com. Możesz skontaktować się z administratorem poprzez e-mail miloxiads(at)gmail.com w sprawach dotyczących danych osobowych.",
    section3Title: "3. Zakres zbieranych danych",
    section3Text: "W ramach korzystania z serwisu mogą być zbierane następujące dane:",
    section3Item1: "adres IP",
    section3Item2: "dane zbierane automatycznie poprzez pliki cookies",
    section3Item3: "imię, nazwisko, adres e-mail, numer telefonu lub inne dane przekazane dobrowolnie poprzez formularze kontaktowe lub zapisy na newsletter",
    section4Title: "4. Cele przetwarzania danych",
    section4Text: "Dane przetwarzane są w następujących celach:",
    section4Item1: "obsługa zapytań wysłanych przez formularze",
    section4Item2: "realizacja usług dostępnych w serwisie",
    section4Item3: "prowadzenie newslettera",
    section4Item4: "statystyki, analityka i poprawa funkcjonalności strony",
    section4Item5: "działania marketingowe realizowane zgodnie z prawem",
    section5Title: "5. Podstawy prawne przetwarzania",
    section5Text: "Dane przetwarzane są na podstawie:",
    section5Item1: "art. 6 ust. 1 lit. a RODO – zgoda użytkownika",
    section5Item2: "art. 6 ust. 1 lit. b RODO – wykonanie umowy lub podjęcie działań przed jej zawarciem",
    section5Item3: "art. 6 ust. 1 lit. f RODO – prawnie uzasadniony interes administratora, jak np. statystyka, marketing, zabezpieczenie roszczeń",
    section6Title: "6. Pliki cookies",
    section6Text: "Strona korzysta z plików cookies w celach technicznych, analitycznych i marketingowych. Możesz zarządzać cookies w ustawieniach przeglądarki.",
    section7Title: "7. Odbiorcy danych",
    section7Text: "Dane mogą być udostępniane:",
    section7Item1: "dostawcom usług technicznych i hostingowych",
    section7Item2: "usługodawcom analitycznym, takim jak narzędzia statystyczne",
    section7Item3: "podmiotom obsługującym mailing lub systemy newsletterowe",
    section7Text2: "Administrator nie sprzedaje danych osobowych.",
    section8Title: "8. Przechowywanie danych",
    section8Text: "Dane przechowywane są przez okres niezbędny do realizacji celów, dla których zostały zebrane lub do momentu wycofania zgody.",
    section9Title: "9. Prawa użytkownika",
    section9Text: "Zgodnie z RODO przysługują Ci prawa:",
    section9Item1: "dostępu do danych",
    section9Item2: "sprostowania",
    section9Item3: "usunięcia",
    section9Item4: "ograniczenia przetwarzania",
    section9Item5: "przenoszenia danych",
    section9Item6: "wniesienia sprzeciwu",
    section9Item7: "wycofania zgody w dowolnym momencie",
    section9Item8: "złożenia skargi do Prezesa UODO",
    section9Text2: "W celu realizacji praw napisz na miloxiads(at)gmail.com.",
    section10Title: "10. Zabezpieczenia danych",
    section10Text: "Administrator stosuje środki techniczne i organizacyjne chroniące dane przed utratą, ujawnieniem i nieuprawnionym dostępem.",
    section11Title: "11. Zmiany Polityki Prywatności",
    section11Text: "Administrator może wprowadzać zmiany w niniejszej polityce. Zmiany będą publikowane na stronie lifactor.com.",
  },
  en: {
    title: "Privacy Policy lifactor.com",
    section1Title: "1. General Information",
    section1Text1: "This Privacy Policy describes the rules for processing personal data of users of the lifactor.com website. The data controller is the owner of the website, contact email: miloxiads(at)gmail.com.",
    section1Text2: "By using the website, you accept the rules described below.",
    section2Title: "2. Data Controller",
    section2Text: "The controller is the entity managing the lifactor.com website. You can contact the controller via email miloxiads(at)gmail.com regarding personal data matters.",
    section3Title: "3. Scope of Collected Data",
    section3Text: "The following data may be collected when using the website:",
    section3Item1: "IP address",
    section3Item2: "data collected automatically through cookies",
    section3Item3: "name, surname, email address, phone number or other data voluntarily provided through contact forms or newsletter subscriptions",
    section4Title: "4. Purposes of Data Processing",
    section4Text: "Data is processed for the following purposes:",
    section4Item1: "handling inquiries sent through forms",
    section4Item2: "providing services available on the website",
    section4Item3: "managing newsletter",
    section4Item4: "statistics, analytics and improving website functionality",
    section4Item5: "marketing activities carried out in accordance with the law",
    section5Title: "5. Legal Basis for Processing",
    section5Text: "Data is processed based on:",
    section5Item1: "Art. 6(1)(a) GDPR – user consent",
    section5Item2: "Art. 6(1)(b) GDPR – contract performance or taking steps prior to entering into a contract",
    section5Item3: "Art. 6(1)(f) GDPR – legitimate interest of the controller, such as statistics, marketing, securing claims",
    section6Title: "6. Cookies",
    section6Text: "The website uses cookies for technical, analytical and marketing purposes. You can manage cookies in your browser settings.",
    section7Title: "7. Data Recipients",
    section7Text: "Data may be shared with:",
    section7Item1: "technical and hosting service providers",
    section7Item2: "analytical service providers, such as statistical tools",
    section7Item3: "entities handling mailing or newsletter systems",
    section7Text2: "The controller does not sell personal data.",
    section8Title: "8. Data Retention",
    section8Text: "Data is stored for the period necessary to achieve the purposes for which it was collected or until consent is withdrawn.",
    section9Title: "9. User Rights",
    section9Text: "Under GDPR, you have the following rights:",
    section9Item1: "access to data",
    section9Item2: "rectification",
    section9Item3: "erasure",
    section9Item4: "restriction of processing",
    section9Item5: "data portability",
    section9Item6: "objection",
    section9Item7: "withdrawal of consent at any time",
    section9Item8: "filing a complaint with the supervisory authority",
    section9Text2: "To exercise your rights, write to miloxiads(at)gmail.com.",
    section10Title: "10. Data Security",
    section10Text: "The controller applies technical and organizational measures to protect data against loss, disclosure and unauthorized access.",
    section11Title: "11. Changes to Privacy Policy",
    section11Text: "The controller may make changes to this policy. Changes will be published on lifactor.com.",
  },
};

export function getPrivacyTranslation(language: Language, key: TranslationKey): string {
  return translations[language][key] || translations.en[key];
}
